import { useMemo } from "react";
import Lockr from "lockr";
import { StorageKeys } from "src/utils/storageKeys";
import type { Permissions } from "src/types/settings";

export const usePermissions = (): Partial<Permissions> =>
	useMemo(() => Lockr.get(StorageKeys.Permissions) ?? {}, []);
